import { HttpClient, HttpHeaders } from '@angular/common/http';
import { sectors, models, SectorModel } from './sector.model';
import { Observable } from 'rxjs';
import { Injectable, EventEmitter } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { msalConfigProps } from '../../environments/environment';

@Injectable()
export class DBConnectorService {

    public SectorName = null;
    public ModelName = null;
    onGetSec = new EventEmitter<string>();
    onGetMod = new EventEmitter<string>();
    public Admin = false;
    public RoleID: string;
    // public UserExists = false;
    public username: string;
    public ipaddress: string;


    constructor(private http: HttpClient, private msalService: MsalService) {
    }

    isadmin(data) {
        return this.http.post<any>('api/Dropdown/IsAdmin', data)
    }

    loggingout(data) {
        return this.http.post<any>('api/Dropdown/LoggingOut', data)
    }

    getsectors() {
        return this.http.get<any>('api/Dropdown/GetSECTOR')
    }

    getUserSector(dbData) {
        return this.http.post<any>('api/Dropdown/GetUserSECTOR', dbData)
    }

    getmodels(sectorname) {
        return this.http.get<any>('api/Dropdown/GetMODEL?sectorId=' + sectorname)
    }

    getallmodels() {
        return this.http.get<any>('api/Dropdown/GetallMODELs')
    }

    getalllabels() {
        return this.http.get<any>('api/ManageLabel/GetallLABELs')
    }

    getallusers() {
        return this.http.get<any>('api/ManageUser/GetallUSERs')
    }

    setSectorModel(sectorname, modelname) {
        this.SectorName = sectorname;
        this.ModelName = modelname;
        this.onGetSec.emit(this.SectorName);
        this.onGetMod.emit(this.ModelName);
    }

    getMultipart(url) {
        const options: object = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            responseType: 'Blob',
            observe: 'response'
        }

        return this.http.post<any>(url, '', options)
            .subscribe(res => {
                return new Blob([res], { type: 'application/octet-stream' });
            });
    }

    terminateProcess() {
        const url = 'api/Home/TerminateProcess';
        return this.http.get<any>(url)
    }

    public getToken(url?) {        
        if(sessionStorage.getItem('msalToken'))
            return 'Bearer ' + sessionStorage.getItem('msalToken')         
    }

    public setToken() {
        const accessTokenRequest = {
            scopes: [msalConfigProps.apiScope],
            account: this.msalService.instance.getActiveAccount()
        }
        this.msalService.instance.acquireTokenSilent(accessTokenRequest).then(response => {
            sessionStorage.setItem('msalToken', response.accessToken)
        })
    }

    getUserProfile() {
        return this.http.get<any>("https://graph.microsoft.com/v1.0/me")
    }
}
